import React, { useState } from "react";
import style from "./input.module.scss";
import toPersianNumber from "../../helpers/actions/toPersianNumber"

const Input = (props) => {


    const [visible, setVisible] = useState(false);
    return (
        <React.Fragment>
            <div className={style.wrapper}>
                {props.label && <label>
                    <span className={style.label}>{props.label}</span>
                    {
                        props.tooltip ?
                            <div className={style.imageHolder}>
                                <div className={style.icon}>h</div>
                                <div className={style.tooltip}>
                                    <div className={style.triangle}></div>
                                    <div className={style.rectangle}>{props.tooltip}</div>
                                </div>
                            </div> : <div></div>
                    }
                </label>}
                <div className={style.inputWrapper}>
                    {props.disabled ? <div></div> :

                        (props.type === "password" ?
                            <div disabled={props.value ? false : true} className={style.icon} onClick={(e) => {
                                setVisible(!visible)
                            }}>
                                {visible ? <span>a</span> : <span>b</span>}
                            </div> : <div></div>)
                    }

                    {props.unit && <div className={style.unitIcon}>{props.unit}</div>}

                    <input disabled={props.disabled}
                        autoComplete={0}
                        placeholder={props.placeholder ? props.placeholder : ""}
                        onChange={e => {
                            props.onchange(props.tag, e, (props.secondTag ? props.secondTag : ""))
                        }}
                        onBlur={e => props.onblur(props.tag, e)}
                        value={props.type === "password" ? toPersianNumber(props.value) : toPersianNumber(props.value) ? toPersianNumber(props.value) : ""}
                        type={!visible ? props.type : "text"}
                        style={props.type == "password" ? { textAlign: 'right', direction: 'ltr' } : {}}
                    />
                    {props.withRial && !props.disabled ? <span>ريال</span> : <span></span>}
                    {props.withPercent && !props.disabled ? <span>درصد</span> : <span></span>}
                    {props.withToman && !props.disabled ? <span>تومان</span> : <span></span>}
                    {props.withMinute && !props.disabled ? <span>دقیقه</span> : <span></span>}
                    {props.withDKPC && !props.disabled ? <span> - DKPC</span> : <span></span>}
                </div>
                <div className={style.errorWrapper}>{props.error}</div>
            </div>
        </React.Fragment>
    )

}

export default Input;
//HOW TO USE
//example
{/* <Input
    secondTag: : type:string 
    type="text"   : type :password/text
    disabled={false} : disabled or enabled :  true/false
    label="نام و نام خانوادگی" : required : label of input 
    placeholder="نام و نام خانوادگی" : placeholder
    tag="n1" : name tag of input 
    value=""  : value passed to input 
    error='! تکمیل این فیلد الزامی است' : error message
    tooltip={" ایمیل ثبت شده در پنل فروشندگان دیجی‌کالاای"}:tooltip 
    onchange={handler} : required handles change 
    onblur={handler} />  : onBlure */
}


